// UX37 (docs/build-briefs/UX37-settings-descriptions.md, DEC-184): every
// settings control points at the text that says what it is for. This is the
// one place that wires the pointer, so check:settings-described has a single
// call to look for.

/** Points `control` at the element whose text describes it. An absent id does
 * nothing, so a shared builder can pass the caller's optional id straight on;
 * the gate (not this function) is what makes a caller supply one. */
export function describeSetting(control: Element, helpId: string | undefined): void {
  if (helpId === undefined || helpId === "") return;
  control.setAttribute("aria-describedby", helpId);
}
